let baseParam = {
  appkey: "6DCC55A836A246BEBAD583EBBA995ED1",
  grant_type: "password",
  scope: "server",
};

var os = (function () {
  var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian;
  return {
    isTablet: isTablet,
    isPhone: isPhone,
    isAndroid: isAndroid,
    isPc: isPc,
  };
})();
function normalizeProductUrlToLowercase(excludeList = []) {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);

  // 匹配路径中 /products/ 后的部分
  const pathMatch = url.pathname.match(/^\/products\/([^/?#]+)(\.html)?$/i);
  if (!pathMatch) return;

  const productNameRaw = pathMatch[1];

  // 没有大写字母就不处理
  if (!/[A-Z]/.test(productNameRaw)) return;

  // 判断是否在排除列表中
  const isExcluded = excludeList.some(
    (name) => name.toLowerCase() === productNameRaw.toLowerCase()
  );
  if (isExcluded) return;

  const lowerCaseName = productNameRaw.toLowerCase();

  // 保留原路径其他部分（例如 .html）、search、hash等
  const newPath = url.pathname.replace(
    /^(\/products\/)([^/?#]+)(\.html)?$/i,
    `$1${lowerCaseName}$3`
  );
  const newUrl = `${url.origin}${newPath}${url.search}${url.hash}`;

  if (newUrl !== currentUrl) {
    window.location.replace(newUrl);
  }
}

$(function () {
    normalizeProductUrlToLowercase([]);
    if (os.isAndroid || os.isPhone) {
        const currentPath = window.location.pathname; // 保留原始大小写
        const currentPathLower = currentPath.toLowerCase(); // 用于路由匹配
        const searchParams = window.location.search; // 查询字符串
        const hashParams = window.location.hash; // hash 部分

        // 所有路由信息完全配置在 JSON 数组中
        const routesConfig = [
            {
                path: "/pages/purchase-center-secure-gateway-tokens",
                redirect: "https://m.topdon.com/pages/purchase-center-secure-gateway-tokens.html",
                preserveSearch: true,
            },
            {
                path: "/products/ct100",
                redirect: "https://m.topdon.com/products/ct100",
                preserveSearch: true,
            },
            {
                path: "/products/tc005",
                redirect: "https://m.topdon.com/products/tc005",
                preserveSearch: true,
            },
            {
                path: "/products/afm-disabler",
                redirect: "https://m.topdon.com/products/afm-disabler",
                preserveSearch: true,
            },
            {
                path: "/products/one-plus",
                redirect: "https://m.topdon.com/products/one-plus",
                preserveSearch: true,
            },
            {
                path: "/products/v4000-hd",
                redirect: "https://m.topdon.com/products/v4000-hd",
                preserveSearch: true,
            },
            {
                path: "/products/one",
                redirect: "https://m.topdon.com/products/one.html",
                preserveSearch: true,
            },
            {
                path: "/products/tc001-max",
                redirect: "https://m.topdon.com/products/tc001-max.html",
                preserveSearch: true,
            },
            {
                path: "/products/rlink-x3",
                redirect: "https://m.topdon.com/products/RLink-X3.html",
                preserveSearch: true,
            },
            {
                path: "/pages/topfix",
                redirect: "https://m.topdon.com/pages/topfix",
                preserveSearch: true,
            },
            {
                path: "/products/ts004-pro",
                redirect: "https://m.topdon.com/products/ts004-pro.html",
                preserveSearch: true,
            },
            {
                path: "/products/bt100",
                redirect: "https://m.topdon.com/products/bt100.html",
                preserveSearch: true,
            },
            {
                path: "/pages/topdon-one-series",
                redirect: "https://m.topdon.com/pages/topdon-one-series.html",
                preserveSearch: true,
            },
            {
                path: "/products/bt200",
                redirect: "https://m.topdon.com/products/bt200.html",
                preserveSearch: true,
            },
            {
                path: "/pages/topdon-apps-thermal-imagers",
                redirect: "https://m.topdon.com/pages/topdon-apps-thermal-imagers.html",
                preserveSearch: true,
            },
            {
                path: "/pages/topdon-testlight-program-topdon-one",
                redirect: "https://m.topdon.com/pages/topdon-testlight-program-topdon-one.html",
                preserveSearch: true,
            },
            {
                path: "/products/v1200air",
                redirect: "https://m.topdon.com/products/V1200Air.html",
                preserveSearch: true,
            },
            {
                path: "/products/artidiag-hd",
                redirect: "https://m.topdon.com/products/ArtiDiag-HD.html",
                preserveSearch: true,
            },

            {
                path: "/products/jumpsurge2000pro",
                redirect: "https://m.topdon.com/products/JumpSurge2000Pro.html",
                preserveSearch: true,
            },
            {
                path: "/products/bt600-plus",
                redirect: "https://m.topdon.com/products/BT600-Plus.html",
                preserveSearch: true,
            },
            {
                path: "/pages/purchase-details-2",
                redirect: "https://m.topdon.com/pages/purchase-details-2.html",
                params: {
                    goodsId: { source: "goodsId" },
                },
            },
            {
                path: "/pages/order-details-2",
                redirect: "https://m.topdon.com/pages/order-details-2.html",
                params: {
                    orderNo: { source: "orderNo" },
                },
            },
            {
                path: "/pages/privacy-policy",
                redirect: "https://m.topdon.com/about_privacy.html",
                preserveSearch: true,
            },
            {
                path: "/products/v4500-plus",
                redirect: "https://m.topdon.com/products/V4500-Plus.html",
                preserveSearch: true,
            },
            {
                path: "/pages/my-devices",
                redirect: "https://m.topdon.com/user_product.html",
                preserveSearch: true,
            },
            {
                path: "/pages/general-payment-terms",
                redirect: "https://m.topdon.com/general-payment-terms.html",
                preserveSearch: true,
            },
            {
                path: "/products/artidiag700",
                redirect: "https://m.topdon.com/products/ArtiDiag700.html",
                preserveSearch: true,
            },
            {
                path: "/products/rlink-lite",
                redirect: "https://m.topdon.com/products/RLink-Lite.html",
                preserveSearch: true,
            },
            {
                path: "/pages/topdon-master-intellectual-property-protection-policy",
                redirect:
                    "https://m.topdon.com/topdon-master-intellectual-property-protection-policy.html",
                preserveSearch: true,
            },
            {
                path: "/products/artidiag600-elite",
                redirect: "https://m.topdon.com/products/ArtiDiag-Elite.html",
                preserveSearch: true,
            },
            {
                path: "/products/v3000",
                redirect: "https://m.topdon.com/products/V3000.html",
                preserveSearch: true,
            },
            {
                path: "/products/tc002c-duo",
                redirect: "https://m.topdon.com/products/TC002C-Duo.html",
                preserveSearch: true,
            },
            {
                path: "/pages/solutions-home-inspection",
                redirect: "https://m.topdon.com/pages/solutions-home-inspection.html",
                preserveSearch: true,
            },
            {
                path: "/products/phoenix-adas-mobile",
                redirect: "https://m.topdon.com/products/phoenix-adas-mobile.html",
                preserveSearch: true,
            },
            {
                path: "/products/phoenix-plus-2",
                redirect: "https://m.topdon.com/products/Phoenix-Plus-2.html",
                preserveSearch: true,
            },
            {
                path: "/pages/after-sales-service-policy",
                redirect: "https://m.topdon.com/after-sales-service-policy.html",
                preserveSearch: true,
            },
            {
                path: "/products/artidiag-eu",
                redirect: "https://m.topdon.com/products/ArtiDiag-EU.html",
                preserveSearch: true,
            },
            {
                path: "/products/ultradiag-moto",
                redirect: "https://m.topdon.com/products/UltraDiag-Moto.html",
                preserveSearch: true,
            },
            {
                path: "/pages/topdon-master-program-application",
                redirect:
                    "https://m.topdon.com/pages/topdon-master-program-application.html",
                preserveSearch: true,
            },
            {
                path: "/pages/topdon-master-program",
                redirect: "https://m.topdon.com/pages/topdon-master-program.html",
                preserveSearch: true,
            },
            {
                path: "/pages/my-topdon-story",
                redirect: "https://m.topdon.com/pages/my-topdon-story.html",
                preserveSearch: true,
            },
            {
                path: "/products/tc004-se",
                redirect: "https://m.topdon.com/products/tc004-se.html",
                preserveSearch: true,
            },
            {
                path: "/products/ts005",
                redirect: "https://m.topdon.com/products/ts005.html",
                preserveSearch: true,
            },
            {
                path: "/products/artidiag600-s-new",
                redirect: "https://m.topdon.com/products/artidiag600-s-new.html",
                preserveSearch: true,
            },
            {
                path: "/products/carpal",
                redirect: "https://m.topdon.com/products/CarPal.html",
                preserveSearch: true,
            },
            {
                path: "/pages/my-topdon-story-application",
                redirect: "https://m.topdon.com/pages/my-topdon-story-application.html",
                preserveSearch: true,
            },
            {
                path: "/pages/my-topdon-story-survey",
                redirect: "https://m.topdon.com/pages/my-topdon-story-survey.html",
                preserveSearch: true,
            },
            {
                path: "/pages/my-topdon-story-terms-and-conditions",
                redirect:
                    "https://m.topdon.com/pages/my-topdon-story-terms-and-conditions.html",
                preserveSearch: true,
            },
            {
                path: "/pages/about-us",
                redirect: "https://m.topdon.com/about.html",
                preserveSearch: true,
            },
            {
                path: "/products/tc004-mini",
                redirect: "https://m.topdon.com/products/TC004-Mini.html",
                preserveSearch: true,
            },
            {
                path: "/products/artidiag600-s",
                redirect: "https://m.topdon.com/products/artidiag600-s.html",
                preserveSearch: true,
            },
            {
                path: "/products/rlink-j2534",
                redirect: "https://m.topdon.com/products/RLink-J2534.html",
                preserveSearch: true,
            },
            {
                path: "/products/ts004",
                redirect: "https://m.topdon.com/products/ts004.html",
                preserveSearch: true,
            },
            {
                path: "/products/tc002c",
                redirect: "https://m.topdon.com/products/TC002C.html",
                preserveSearch: true,
            },
            {
                path: "/products/artidiag-pro",
                redirect: "https://m.topdon.com/products/ArtiDiag-Pro.html",
                preserveSearch: true,
            },
            {
                path: "/products/tornado120000",
                redirect: "https://m.topdon.com/products/Tornado120000.html",
                preserveSearch: true,
            },
            {
                path: "/products/artidiag800-bt-2",
                redirect: "https://m.topdon.com/products/artidiag800-bt-2.html",
                preserveSearch: true,
            },
            {
                path: "/products/phoenix-xlink",
                redirect: "https://m.topdon.com/products/Phoenix-XLink.html",
                preserveSearch: true,
            },
            {
                path: "/products/bt600-plus",
                redirect:
                    "https://m.topdon.com/diagnostic_detail.html?name=BT600%20Plus",
                preserveSearch: true,
            },
            {
                path: "/products/bt600",
                redirect: "https://m.topdon.com/products/BT600.html",
                preserveSearch: true,
            },
            {
                path: "/products/tc001-plus",
                redirect: "https://m.topdon.com/products/TC001-Plus.html",
                preserveSearch: true,
            },
            {
                path: "/products/phoenix-lite-3",
                redirect: "https://m.topdon.com/products/Phoenix-Lite-3.html",
                preserveSearch: true,
            },
            {
                path: "/products/jumpsurge1200pro",
                redirect: "https://m.topdon.com/products/JumpSurge1200Pro.html",
                preserveSearch: true,
            },
            {
                path: "/pages/terms-of-use",
                redirect: "https://m.topdon.com/about_terms.html",
                preserveSearch: true,
            },
            {
                path: "/products/v2200plus",
                redirect: "https://m.topdon.com/products/V2200Plus.html",
                preserveSearch: true,
            },
            {
                path: "/products/v2200air",
                redirect: "https://m.topdon.com/products/V2200Air.html",
                preserveSearch: true,
            },
            {
                path: "/pages/28-or-more-maintenance-services-testlight-program",
                redirect:
                    "https://m.topdon.com/pages/28-or-more-maintenance-services-testlight-program.html",
                preserveSearch: true,
            },
            {
                path: "/pages/optional-cable-query-for-topscan-moto",
                redirect:
                    "https://m.topdon.com/pages/optional-cable-query-for-topscan-moto.html",
                preserveSearch: true,
            },
            {
                path: "/products/tb6000pro",
                redirect: "https://m.topdon.com/diagnostic_detail.html?name=TB6000Pro",
                preserveSearch: true,
            },
            {
                path: "/products/pulseq-ac-home",
                redirect: "https://m.topdon.com/products/pulseq-ac-home.html",
                preserveSearch: true,
            },
            {
                path: "/products/ts001",
                redirect: "https://m.topdon.com/products/TS001.html",
                preserveSearch: true,
            },
            {
                path: "/products/topscan",
                redirect: "https://m.topdon.com/products/TopScan.html",
                preserveSearch: true,
            },
            {
                path: "/products/ultradiag",
                redirect: "https://m.topdon.com/products/UltraDiag.html",
                preserveSearch: true,
            },
            {
                path: "/products/topscan-moto",
                redirect: "https://m.topdon.com/products/topscan-moto.html",
                preserveSearch: true,
            },
            {
                path: "/pages/software-download",
                redirect: "https://m.topdon.com/user_download.html",
                preserveSearch: true,
            },
            {
                path: "/pages/purchase-center",
                redirect: "https://m.topdon.com/purchase_center.html",
                preserveSearch: true,
            },
            {
                path: "/pages/support-warranty",
                redirect: "https://m.topdon.com/support_warranty.html",
                preserveSearch: true,
            },
            {
                path: "/pages/library-down",
                redirect: "https://m.topdon.com/more.html",
                preserveSearch: true,
            },
            {
                path: "/pages/support-main",
                redirect: "https://m.topdon.com/support.html",
                preserveSearch: true,
            },
            {
                path: "/pages/tech-support",
                redirect: "https://m.topdon.com/support_tech.html",
                preserveSearch: true,
            },
            {
                path: "/pages/vehicle-coverage",
                redirect: "https://m.topdon.com/vehicle-coverage.html",
                preserveSearch: true,
            },
            {
                path: "/pages/support-key-programmer",
                redirect: "https://m.topdon.com/model/programmer.html",
                preserveSearch: true,
            },
            {
                path: "/account/login",
                redirect: "https://m.topdon.com/login.html",
                preserveSearch: true,
            },
            {
                path: "/pages/authorized-dealer",
                redirect: "https://m.topdon.com/where_auth.html",
                preserveSearch: true,
            },
            {
                path: "/pages/online-store",
                redirect: "https://m.topdon.com/where_online.html",
                preserveSearch: true,
            },
            {
                path: "/pages/offline-store",
                redirect: "https://m.topdon.com/where_offline.html",
                preserveSearch: true,
            },
            {
                path: "/pages/cooperation",
                redirect: "https://m.topdon.com/cooperation_form.html",
                preserveSearch: true,
            },
            {
                path: "/pages/top-up-program",
                redirect: "https://m.topdon.com/pages/top-up-program.html",
                preserveSearch: true,
            },
            {
                path: "/pages/product-authenticity-check",
                redirect: "https://m.topdon.com/pages/product-authenticity-check.html",
                preserveSearch: true,
            },
            {
                path: "/pages/phoenix-remote-lease-program",
                redirect:
                    "https://m.topdon.com/pages/phoenix-remote-lease-program.html",
                preserveSearch: true,
            },
            {
                path: "/pages/topdon-testlight-program",
                redirect: "https://m.topdon.com/pages/topdon-testlight-program.html",
                preserveSearch: true,
            },
            {
                path: "/pages/cookie-policy",
                redirect: "https://m.topdon.com/pages/cookie-policy.html",
                preserveSearch: true,
            },
            {
                path: "/pages/installation-bonus-campaign-for-pulseq-ev-charger",
                redirect:
                    "https://m.topdon.com/pages/installation-bonus-campaign-for-pulseq-ev-charger.html",
                preserveSearch: true,
            },
            {
                path: "/pages/topscan-motorcycle-diagnostic-software-project",
                redirect:
                    "https://m.topdon.com/pages/topscan-motorcycle-diagnostic-software-project.html",
                preserveSearch: true,
            },
            {
                path: "/pages/download-product-catalog",
                redirect: "https://m.topdon.com/pages/download-product-catalog.html",
                preserveSearch: true,
            },
            {
                path: "/pages/news",
                redirect: "https://m.topdon.com/new_list.html",
                preserveSearch: true,
            },
            {
                path: "/pages/careers",
                redirect: "https://m.topdon.com/contact_careers.html",
                preserveSearch: true,
            },
            {
                path: "/pages/topdon-diagnostic-scanners-re-listed-on-autoauth",
                redirect:
                    "https://m.topdon.com/pages/topdon-diagnostic-scanners-re-listed-on-autoauth.html",
                preserveSearch: true,
            },
            {
                path: "/pages/contact-us",
                redirect: "https://m.topdon.com/contact_topdon.html",
                preserveSearch: true,
            },
            {
                path: "/pages/purchase-details",
                redirect: "https://m.topdon.com/purchase_details.html",
                preserveSearch: true,
            },
            {
                path: "/pages/product-inquiries",
                redirect: "https://m.topdon.com/product_inquiries.html",
                preserveSearch: true,
            },
            {
                path: "/pages/product-feedback",
                redirect: "https://m.topdon.com/product_feedback.html",
                preserveSearch: true,
            },
            {
                path: "/pages/replacement-repair-services",
                redirect: "https://m.topdon.com/replacement-repair-services.html",
                preserveSearch: true,
            },
            {
                path: "/products/artidiag-moto",
                redirect: "https://m.topdon.com/products/ArtiDiag-Moto.html",
                preserveSearch: true,
            },
            {
                path: "/pages/track-request",
                redirect: "https://m.topdon.com/track-request.html",
                preserveSearch: true,
            },
            // 动态路由：根据 query 参数构造目标 URL
            {
                path: "/pages/pro-down",
                redirect: "https://m.topdon.com/diagnostic_detail_down.html",
                params: {
                    name: { source: "fuzzy", transform: "dashToSpace" },
                },
            },
            {
                path: "/pages/pro-prama",
                redirect: "https://m.topdon.com/diagnostic_detail_specs.html",
                params: {
                    name: { source: "fuzzy", transform: "dashToSpace" },
                },
            },
            {
                path: "/pages/pro-acc",
                redirect: "https://m.topdon.com/diagnostic_detail_acc.html",
                params: {
                    name: { source: "fuzzy", transform: "dashToSpace" },
                },
            },
            {
                path: "/pages/pro-faq",
                redirect: "https://m.topdon.com/diagnostic_detail_faq.html",
                params: {
                    name: { source: "fuzzy", transform: "dashToSpace" },
                },
            },
            {
                path: "/pages/pro-video",
                redirect: "https://m.topdon.com/diagnostic_detail_video.html",
                params: {
                    name: { source: "fuzzy", transform: "dashToSpace" },
                },
            },
            {
                path: "/pages/news-detail",
                redirect: "https://m.topdon.com/new_detail.html",
                params: {
                    id: { source: "id" },
                },
            },
            {
                path: "/pages/tools-tablet",
                redirect: "https://m.topdon.com/diagnostic_son.html",
                params: {
                    classId: { source: "classId" },
                },
            },
            {
                path: "/pages/tools-tablet.html",
                redirect: "https://m.topdon.com/diagnostic_son.html",
                params: {
                    classId: { source: "classId" },
                },
            },
            {
                path: "/pages/track-request-detail.html",
                redirect: "https://m.topdon.com/track-request-detail.html",
                params: {
                    email: { source: "email" },
                    ticketNumber: { source: "ticketNumber" },
                },
            },
            {
                path: "/pages/track-request-detail",
                redirect: "https://m.topdon.com/track-request-detail.html",
                params: {
                    email: { source: "email" },
                    ticketNumber: { source: "ticketNumber" },
                },
            },
            {
                path: "/pages/tools",
                redirect: "https://m.topdon.com/tools",
                preserveSearch: true,
                preservePath: true, // 保留路径部分，如 /pages/tools/Diagnostic-Tools -> /tools/Diagnostic-Tools
            },
            {
                path: "/pages/campus-detail",
                redirect: "https://m.topdon.com/contact_careers_detail.html",
                params: {
                    id: { source: "id" },
                },
            },
            {
                path: "/pages/campus-detail.html",
                redirect: "https://m.topdon.com/contact_careers_detail.html",
                params: {
                    id: { source: "id" },
                },
            },
            {
                path: "/pages/campus",
                redirect: "https://m.topdon.com/contact_careers_list.html",
                params: {
                    type: { source: "type" },
                },
            },
            {
                path: "/search",
                redirect: "https://m.topdon.com/search.html",
                params: {
                    val: { source: "q" }
                }
            },
            // 示例：仅需保留查询参数（已在静态配置中体现），或者其他需要特殊处理的可以在此补充
            {
                path: "/pages/comparison",
                redirect: "https://m.topdon.com/pages/comparison.html",
                preserveSearch: true,
            },
        ];
        // 辅助方法：转换将横杠替换为空格
        function dashToSpace(str) {
            return str.replace(/-/g, " ");
        }

        // 辅助方法：根据 key 从 URL 查询参数中获取值
        function getQueryVariable(variable) {
            const query = window.location.search.substring(1);
            const vars = query.split("&");
            for (let i = 0; i < vars.length; i++) {
                const pair = vars[i].split("=");
                if (pair[0] === variable) return decodeURIComponent(pair[1] || "");
            }
            return "";
        }

        for (let route of routesConfig) {
            let isMatch = false;
            let pathSuffix = '';

            // 精确匹配（使用小写进行匹配）
            if (currentPathLower === route.path || currentPathLower === `${route.path}.html`) {
                isMatch = true;
            }
            // 路径前缀匹配（用于 /pages/tools/XXX 这种格式）
            else if (route.preservePath && currentPathLower.startsWith(route.path + '/')) {
                isMatch = true;
                // 使用原始大小写提取路径后缀
                pathSuffix = currentPath.substring(route.path.length); // 提取 /XXX 部分（保留大小写）
            }

            if (isMatch) {
                let targetUrl = route.redirect + pathSuffix; // 添加路径后缀
                if (route.preserveSearch) {
                    targetUrl += searchParams;
                }
                if (route.params) {
                    let queryParts = [];
                    for (let key in route.params) {
                        const cfg = route.params[key];
                        let value = getQueryVariable(cfg.source);
                        if (value && cfg.transform === "dashToSpace") {
                            value = dashToSpace(value);
                        }
                        if (value) {
                            queryParts.push(key + "=" + encodeURIComponent(value));
                        }
                    }
                    if (queryParts.length > 0) {
                        targetUrl +=
                            (targetUrl.indexOf("?") === -1 ? "?" : "&") +
                            queryParts.join("&");
                    }
                }
                // 保留 hash 部分
                if (hashParams) {
                    targetUrl += hashParams;
                }
                window.location.href = targetUrl;
                return;
            }
        }
        if (currentPath.startsWith("/products/")) {
            let productNameRaw = window.location.pathname.substring("/products/".length);
            if (productNameRaw.endsWith(".html")) {
                productNameRaw = productNameRaw.slice(0, -5);
            }
            const encodedName = encodeURIComponent(productNameRaw.toLowerCase().replace(/-/g, " "));
            return;
        }
        window.location.href = "https://m.topdon.com" + searchParams;
    } else {
        let gaTag = document.createElement("script");
        gaTag.type = "text/javascript";
        gaTag.async = true;

        gaTag.src = "https://www.googletagmanager.com/gtag/js?id=UA-217568826-1";
        let root_s = document.getElementsByTagName("script")[0];
        root_s.parentNode.insertBefore(gaTag, root_s);
        window.dataLayer = window.dataLayer || [];

        function gtag() {
            dataLayer.push(arguments);
        }

        gtag("js", new Date());

        gtag("config", "UA-217568826-1");
        // 查询第一个包含 fuzzy 参数的链接
        const firstFuzzyLink = $(
            ".bg-theme .wrapper .nav-sub-tabs a[href*='fuzzy']"
        ).first();

        if (firstFuzzyLink.length) {
            const href = firstFuzzyLink.attr("href");
            const fuzzyValue = new URLSearchParams(href.split("?")[1]).get("fuzzy");
            setNewNav(fuzzyValue);
        }
    }
});

function setNewNav(fuzzyValue) {
  const headers = { "X-Requested-With": "Hiwie-Fetch" };
  const requestInfo = $.ajax({
    url: `https://official-web-api.topdon.com/api/product/info?name=${encodeURIComponent(
      fuzzyValue
    )}`,
    type: "GET",
    headers,
  });
  const requestName = $.ajax({
    url: `https://official-web-api.topdon.com/api/products/name?productName=${encodeURIComponent(
      fuzzyValue
    )}&draft=false`,
    type: "GET",
    headers,
  });

  Promise.all([requestInfo, requestName])
    .then(([infoRes, nameRes]) => {
      console.log("产品名称数据：", nameRes);
      const { allowPurchase, urlAu, urlEu, urlUs } = infoRes?.success || {};
      const isProduct = location.pathname.toLowerCase().includes("/products/");
      let buyButtonHtml = "";

      if (allowPurchase) {
        const siteLinks = [
          { key: "us", url: urlUs, title: "United States", icon: "us" },
          { key: "eu", url: urlEu, title: "Europe", icon: "eu" },
          { key: "au", url: urlAu, title: "Australia", icon: "au" },
        ]
          .filter(({ url }) => url)
          .map(
            ({ key, url, title, icon }) => `
            <a target="_blank" data-index="${key}" class="p-header-buyButton-main-list" href="${url}">
              <img src="https://cdn.shopify.com/s/files/1/0590/5789/7634/files/p-header-buyButton-icon-${icon}.png?v=1750313367" class="p-header-buyButton-main-img" />
              <div class="p-header-buyButton-main-list-title">${title}</div>
            </a>`
          )
          .join("");

        buyButtonHtml = `
          <li>
            <div class="p-header-buyButton">
              <span>Shop Now</span>
              <div class="p-header-buyButton-list-box">
                <div class="p-header-buyButton-main-box">
                  <div class="p-header-buyButton-main-title" style="${
                    !urlUs && !urlEu && !urlAu ? "padding-bottom: 0;" : ""
                  }">
                    Official Site
                  </div>
                  ${siteLinks}
                  <div class="p-header-buyButton-main-list-line"></div>
                  <a target="_blank" data-index="other" class="p-header-buyButton-main-list" href="https://www.topdon.com/pages/online-store">
                    <img src="https://cdn.shopify.com/s/files/1/0590/5789/7634/files/p-header-buyButton-icon-all.png?v=1750313367" class="p-header-buyButton-main-img" />
                    <div class="p-header-buyButton-main-list-title">Other Regions & Channels</div>
                  </a>
                </div>
              </div>
            </div>
          </li>
        `;
      }

      // 生成导航html
      let htmls = "";
      if (nameRes.code === 2000 && nameRes?.success) {
        const s = nameRes.success;
        const baseUrl = isProduct
          ? "javascript:void(0)"
          : `/products/${fuzzyValue.toLowerCase().split(" ").join("-")}`;
        
        if (s.compare === true) {
          htmls = `
            <li><a href="${baseUrl}">Overview</a></li>
            <li><a href="/pages/pro-prama?fuzzy=${fuzzyValue}">Specs</a></li>
            <li><a href="/pages/comparison?classificationCode=${s.compareClassificationCode}&nowSelect=${s.id}">Comparison</a></li>
            <li><a href="/pages/pro-down?fuzzy=${fuzzyValue}">Download</a></li>
            <li><a href="/pages/pro-acc?fuzzy=${fuzzyValue}">Accessories</a></li>
            <li><a href="/pages/pro-video?fuzzy=${fuzzyValue}">Video</a></li>
            <li><a href="/pages/pro-faq?fuzzy=${fuzzyValue}">FAQ</a></li>
            ${buyButtonHtml}
          `;
        }  else {
          htmls = `
            <li><a href="${baseUrl}">Overview</a></li>
            <li><a href="/pages/pro-prama?fuzzy=${fuzzyValue}">Specs</a></li>
            <li><a href="/pages/pro-down?fuzzy=${fuzzyValue}">Download</a></li>
            <li><a href="/pages/pro-acc?fuzzy=${fuzzyValue}">Accessories</a></li>
            <li><a href="/pages/pro-video?fuzzy=${fuzzyValue}">Video</a></li>
            <li><a href="/pages/pro-faq?fuzzy=${fuzzyValue}">FAQ</a></li>
            ${buyButtonHtml}
          `;
        }

        $(".bg-theme .wrapper .nav-sub-tabs").html(htmls);

        const fixedNavHtml = `
          <div class="bg-theme" id="bg-theme-fixed" style="position: fixed;top: 0;left: 0;right: 0;display:none;z-index:20;">
            <div class="wrapper">
              <ul class="nav-sub-tabs">${htmls}</ul>
            </div>
          </div>
        `;

        $(".template-product, .template-page").append(fixedNavHtml);

        if (allowPurchase) {
          const REPORT_KEY_PREFIX = "buy_button_click_";
          const REPORT_EXPIRATION = 10 * 60 * 1000;

          function shouldReportClick(index, fuzzyValue) {
            const key = REPORT_KEY_PREFIX + index + "_" + fuzzyValue;
            const lastTime = localStorage.getItem(key);
            const now = Date.now();
            if (!lastTime || now - parseInt(lastTime, 10) > REPORT_EXPIRATION) {
              localStorage.setItem(key, now.toString());
              return true;
            }
            return false;
          }

          function throttle(fn, delay) {
            let timer = null;
            return function (...args) {
              if (timer) return;
              timer = setTimeout(() => {
                fn.apply(this, args);
                timer = null;
              }, delay);
            };
          }

          const reportClick = throttle((index, fuzzyValue) => {
            if (!shouldReportClick(index, fuzzyValue)) return;
            $.ajax({
              url: "https://official-web-api.topdon.com/api/log/click",
              method: "POST",
              headers: { "X-Requested-With": "Hiwie-Fetch" },
              data: { menuName: index, productName: fuzzyValue },
            });
          }, 1000);

          $(document)
            .off("click", ".p-header-buyButton-main-list")
            .on("click", ".p-header-buyButton-main-list", function (e) {
              e.preventDefault();
              const href = $(this).attr("href");
              const index = $(this).data("index");
              reportClick(index, fuzzyValue);
              window.open(href, "_blank");
            });
        }

        $(window).on("scroll", () => {
          const $nav = $("#PageContainer .bg-theme .wrapper .nav-sub-tabs");
          if ($nav.length) {
            const rect = $nav[0].getBoundingClientRect();
            $("#bg-theme-fixed").css(
              "display",
              rect.top < 0 || rect.bottom > $(window).height()
                ? "block"
                : "none"
            );
          }
        });

        
      }
    })
    .catch((error) => {
      console.error("请求出错：", error);
    });
}

$(function () {
  //sort by 下拉列表
  $(".selectskin .form-text").on("click", function () {
    $(this).next("ul").toggle();
  });
  $(".selectskin i").on("click", function () {
    $(this).parents(".selectskin").find("ul").toggle();
  });
  $(".selectskin ul li").on("click", function () {
    var $selbox = $(this).parents(".selectskin");
    var text = $(this).html();
    $selbox.find(".form-text").val(text);
    var val = $(this).attr("data-val");
    $selbox.find(".form-val").val(val);
    $selbox.find(".form-val").change();
    $(this).addClass("selected").siblings().removeClass("selected");
    $selbox.find("ul").hide();
  });
  //$(".selectskin ul li:eq(0)").click();
  $(".selectskin").each(function () {
    $(this).find("ul li.selected").click();
  });
  $(document).click(function (event) {
    var $sel = $(".selectskin"); // 设置目标区域
    if (!$sel.is(event.target) && $sel.has(event.target).length === 0) {
      //$('#divTop').slideUp('slow');  //滑动消失
      $(".selectskin ul").hide();
    }
  });
});

function initUnreadMessage(success) {
  if (getCookie("access_token")) {
    postWithSign(
      "/api/v1/msg/msgSendLog/getUnread",
      {},
      { terminalId: "1003" },
      function (data) {
        let unreadCount = data.allUnreadRow ? data.allUnreadRow : 0;
        $("#user-nav-message").html("Messages(" + unreadCount + ")");
        if (success) {
          success(data);
        }
      }
    );
  } else {
    if (success) {
      success();
    }
  }

  $(".user-menu>ul>li>a").click(function () {
    let $subul = $(this).next("ul");
    if ($subul.length > 0) {
      if ($subul.is(":hidden")) {
        $subul.show();
      } else {
        $subul.hide();
      }
      return false;
    }
  });
}

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

function setCookie(name, value, domain) {
  //设置名称为name,值为value的Cookie
  var expdate = new Date(); //初始化时间
  expdate.setTime(expdate.getTime() + 24 * 3600000); //时间
  let cookieStr =
    name + "=" + value + ";expires=" + expdate.toGMTString() + ";path=/";
  if (domain) {
    cookieStr += ";domain=" + domain;
  }
  document.cookie = cookieStr;

  //即document.cookie= name+"="+value+";path=/";   时间可以不要，但路径(path)必须要填写，因为JS的默认路径是当前页，如果不填，此cookie只在当前页面生效！~
}

/**按ascii码从小到大排序
 *
 * @param obj
 * @returns {string}
 */
function sort_ascii(obj) {
  let arr = new Array();
  let num = 0;
  for (let i in obj) {
    arr[num] = i;
    num++;
  }
  let sortArr = arr.sort();
  //let sortObj = {};    //完成排序值
  let str = ""; //自定义排序字符串
  for (let i in sortArr) {
    str += sortArr[i] + "=" + obj[sortArr[i]] + "&";
    //sortObj[sortArr[i]] = obj[sortArr[i]];
  }
  //去除两侧字符串
  let char = "&";
  str = str.replace(new RegExp("^\\" + char + "+|\\" + char + "+$", "g"), "");

  return str;
}

function getCookie(name) {
  let arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

function delCookie(name, domain = "", path = "/") {
  const expires = new Date(0).toUTCString();
  let cookie = `${name}=;expires=${expires};path=${path}`;
  if (domain) {
    cookie += `;domain=${domain}`;
  }
  document.cookie = cookie;
}

function showTip(msg, duration, type, callback) {
  duration = isNaN(duration) ? 3000 : duration;
  let box = document.createElement("div");
  let container = document.createElement("div");
  let img = document.createElement("img");
  let text = document.createElement("div");
  box.className = "toast";
  container.className = "container-box";
  text.className = "text";
  text.innerHTML = msg;
  if (type === "error") {
    if (msg.length > 76) {
      img.src =
        "https://cdn.shopifycdn.net/s/files/1/0590/5789/7634/files/icon-error_2x_d5fd19bd-a8ca-450e-9115-d4aa5bf0e515.png?v=1648656070";
      text.style.cssText = "line-height:20px";
    } else {
      box.style.cssText = "width:40%";
      img.src =
        "https://cdn.shopifycdn.net/s/files/1/0590/5789/7634/files/icon-error.png?v=1648656070";
    }
  } else {
    img.src =
      "https://cdn.shopify.com/s/files/1/0590/5789/7634/files/icon-success.png?v=1740561972";
  }
  box.appendChild(container);
  container.appendChild(img);
  container.appendChild(text);
  document.body.appendChild(box);
  setTimeout(function () {
    let d = 0.5;
    box.style.webkitTransition =
      "-webkit-transform " + d + "s ease-in, opacity " + d + "s ease-in";
    box.style.opacity = "0";
    setTimeout(function () {
      document.body.removeChild(box);
      if (callback) {
        callback();
      }
    }, d * 1000);
  }, duration);
}

function showToast(msg, duration, callback) {
  duration = isNaN(duration) ? 3000 : duration;
  let m = document.createElement("div");
  m.id = "toast-container";
  m.innerHTML = msg;
  m.style.cssText =
    "width:40%; min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:40%; left:40%; z-index:999999;";
  if ($("#toast-container").length <= 0) {
    document.body.appendChild(m);
    setTimeout(function () {
      let d = 0.5;
      m.style.webkitTransition =
        "-webkit-transform " + d + "s ease-in, opacity " + d + "s ease-in";
      m.style.opacity = "0";
      setTimeout(function () {
        document.body.removeChild(m);
        if (callback) {
          callback();
        }
      }, d * 1000);
    }, duration);
  }
}

function showToastCenter(msg, duration, callback) {
  duration = isNaN(duration) ? 3000 : duration;
  let m = document.createElement("div");
  m.id = "toast-container";
  m.innerHTML = msg;
  m.style.cssText =
    "width:40%; min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:40%; left:30%; z-index:999999;";
  if ($("#toast-container").length <= 0) {
    document.body.appendChild(m);
    setTimeout(function () {
      var d = 0.5;
      m.style.webkitTransition =
        "-webkit-transform " + d + "s ease-in, opacity " + d + "s ease-in";
      m.style.opacity = "0";
      setTimeout(function () {
        document.body.removeChild(m);
        if (callback) {
          callback();
        }
      }, d * 1000);
    }, duration);
  }
}

function encrypt(str) {
  let key = CryptoJS.enc.Utf8.parse("thanks,lenkor123");
  let iv = CryptoJS.enc.Utf8.parse("thanks,lenkor123");
  let srcs = CryptoJS.enc.Utf8.parse(str);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

function getFullUrl(uri) {
  var regex = /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
  if (regex.test(uri)) {
    return uri;
  } else {
    return "https://official-web-api.topdon.com" + uri;
  }
}
function isPlainObject(value) {
  return Object.prototype.toString.call(value) === "[object Object]";
}
function sendRequest(
  uri,
  method,
  headers,
  param,
  successCallback,
  errorCallback
) {
  headers["clientType"] = 3;
  $.ajax({
    url: getFullUrl(uri),
    type: method,
    contentType: "application/json;charset=utf-8",
    data: JSON.stringify(param),
    headers: headers,
    dataType: "json",
    success: function (data) {
      if (data.code === 2000) {
        if (
          data?.success &&
          (isPlainObject(data?.success) || Array.isArray(data?.success))
        ) {
          successCallback(data);
        } else {
          successCallback(data?.data);
        }
      } else {
        if (errorCallback) {
          errorCallback(data);
        }
      }
    },
    error: function (data) {
      if (data.status === 401) {
        delCookie("access_token");
        window?.localStorage?.removeItem("CS_Time");
        let url = window.location.href;
        location.href = "/account/login?returnTo=" + url;
      } else {
        let json = data.responseJSON;
        errorCallback(json);
      }
    },
  });
}
function getFullUrl(uri) {
  var regex = /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
  if (regex.test(uri)) {
    return uri;
  } else {
    return "https://official-web-api.topdon.com" + uri;
  }
}
function sendRequestWithQs(
  uri,
  method,
  headers,
  param,
  successCallback,
  errorCallback
) {
  headers["clientType"] = 3;
  $.ajax({
    url: getFullUrl(uri),
    type: method,
    data: param,
    headers: headers,
    dataType: "json",
    success: function (data) {
      if (data.code === 2000) {
        successCallback(data);
      } else {
        showToast(data.msg, 3000);
        if (errorCallback) {
          errorCallback(data);
        }
      }
    },
    error: function (data) {
      if (data.status === 401) {
        let url = window.location.href;
        window?.localStorage?.removeItem("CS_Time");
        location.href = "/account/login?returnTo=" + url;
      } else {
        let json = data.responseJSON;
        showToast(json.msg, 3000);
        errorCallback(json);
      }
    },
  });
}

function uploadFile(formData, successCallback, errorCallback) {
  let accessToken = getCookie("access_token");
  let token = {
    Authorization: accessToken ? accessToken : "Basic bGVua29yOmxlbmtvcg==",
    clientType: 3,
  };
  let url = getSign("/api/v1/oss/file/uploadFile", {});
  $.ajax({
    url: "https://official-web-api.topdon.com" + url,
    type: "POST",
    data: formData,
    headers: token,
    contentType: false,
    processData: false,
    success: function (data) {
      if (data.code === 2000) {
        if (
          data?.success &&
          (isPlainObject(data?.success) || Array.isArray(data?.success))
        ) {
          successCallback(data);
        } else {
          successCallback(data?.data);
        }
      } else {
        showToast("Problem encountered, please try again later.", 3000);
      }
    },
    error: function (data) {
      errorCallback(data);
    },
  });
}

function randomString(len) {
  len = len || 32;
  let $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  let maxPos = $chars.length;
  let pwd = "";
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

function getServerTime() {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", "https://official-web-api.topdon.com/time");
    xhr.onload = function () {
      if (xhr.status === 200) {
        resolve(xhr.responseText);
        console.log("success", xhr.responseText);
      } else {
        reject(xhr.statusText);
        console.log("getTimeError", xhr.statusText);
      }
    };
    xhr.onerror = function () {
      reject(xhr.statusText);
      console.log("getTimeError", xhr.statusText);
    };
    xhr.send();
  });
}

function signin(param, successCallback, errorCallback) {
  postOwner(
    "/topdon_user/signin",
    param,
    function (data) {
      setCookie("sid", data.sid, "topdon.com");
      setCookie("access_token", data.tokenType + " " + data.accessToken);
      getServerTime()
        ?.then((res) => {
          let result = JSON.parse(res);
          window?.localStorage?.setItem(
            "CS_Time",
            `${(+result?.timestamp)?.toFixed(0)}000` - new Date()?.getTime()
          );
          successCallback(data);
        })
        ?.catch((err) => {
          successCallback(data);
          console.log(err);
        });
    },
    errorCallback
  );
}

function getSign(uri, param) {
  const serverTime = window?.localStorage?.getItem("CS_Time");
  let timestamp = new Date().getTime();
  if (serverTime !== undefined && serverTime !== null) {
    timestamp += +serverTime;
  }
  let nonceStr = randomString(10);
  let paramData = $.extend({}, baseParam, {
    nonceStr: nonceStr,
    timestamp: timestamp,
  });
  let signTemp = sort_ascii($.extend({}, param, paramData));
  let hash = CryptoJS.MD5(
    signTemp + "&appSecret=DAC450E89BEB43B5B02CD6BE82B8C76E"
  )
    .toString()
    .toUpperCase();
  return uri + "?" + signTemp + "&sign=" + hash;
}

function getWithSign(uri, headers, param, successCallback, errorCallback) {
  let accessToken = getCookie("access_token");
  let token = {
    Authorization: accessToken ? accessToken : "Basic bGVua29yOmxlbmtvcg==",
  };
  let url = getSign(uri, param);
  sendRequestWithQs(
    url,
    "GET",
    $.extend({}, headers, token),
    {},
    function (data) {
      if (
        data?.success &&
        (isPlainObject(data?.success) || Array.isArray(data?.success))
      ) {
        successCallback(data);
      } else {
        successCallback(data?.data);
      }
    },
    errorCallback
  );
}

function postWithSign(uri, headers, param, successCallback, errorCallback) {
  let accessToken = getCookie("access_token");
  let token = {
    Authorization: accessToken ? accessToken : "Basic bGVua29yOmxlbmtvcg==",
  };
  let url = getSign(uri, {});
  sendRequest(
    url,
    "POST",
    $.extend({}, headers, token),
    param,
    successCallback,
    errorCallback
  );
}

function postWithSignQs(uri, headers, param, successCallback, errorCallback) {
  let accessToken = getCookie("access_token");
  let token = {
    Authorization: accessToken ? accessToken : "Basic bGVua29yOmxlbmtvcg==",
  };
  let url = getSign(uri, param);
  sendRequestWithQs(
    url,
    "POST",
    $.extend({}, headers, token),
    param,
    successCallback,
    errorCallback
  );
}

function get(uri, headers, param, successCallback, errorCallback) {
  sendRequest(uri, "GET", headers, param, successCallback, errorCallback);
}

function post(uri, headers, param, successCallback, errorCallback) {
  sendRequest(uri, "POST", headers, param, successCallback, errorCallback);
}

function getOwner(uri, param, successCallback, errorCallback) {
  sendRequestOwner(uri, "GET", {}, param, successCallback, errorCallback);
}

function postOwner(uri, param, successCallback, errorCallback) {
  sendRequestOwner(uri, "POST", {}, param, successCallback, errorCallback);
}

function uploadFileOwner(formData, successCallback, errorCallback) {
  let token = { "X-Requested-With": "Hiwie-Fetch" };
  let url = "https://official-web-api.topdon.com/api/file";
  $.ajax({
    url: url,
    type: "POST",
    data: formData,
    headers: token,
    contentType: false,
    processData: false,
    success: function (data) {
      if (data.success) {
        successCallback(data.success);
      } else {
        if (errorCallback) {
          errorCallback(data);
        }
      }
    },
    error: function (data) {
      errorCallback(data);
    },
  });
}

let ignoreCode = [
  "ERROR.SECURITY.USER.INCORRECT_ACCOUNT_OR_PASSWORD",
  "ERROR.SECURITY.USER.NOT_FOUND",
  "ERROR.WEBSITE.API.ERROR",
  "ERROR.WEBSITE.SUBSCRIBE.EXISTS",
  "ERROR.WEBSITE.CART.EXISTS",
  "ERROR.WEBSITE.WEBSITE_SETTING.NOT_FOUNT",
  "ERROR.WEBSITE.CART.NOT_FOUND",
];
function sendRequestOwner(
  uri,
  method,
  headers,
  param,
  successCallback,
  errorCallback
) {
  headers["X-Requested-With"] = "Hiwie-Fetch";
  if (typeof param === "string") {
    headers["Content-Type"] = "application/json";
  }
  $.ajax({
    url: "https://official-web-api.topdon.com/api" + uri,
    type: method,
    data: param,
    headers: headers,
    dataType: "json",
    xhrFields: {
      withCredentials: true,
    },
    success: function (data) {
      if (data.success) {
        successCallback(data.success);
      } else {
        if (
          ignoreCode.filter((item) => {
            return data.error.code === item;
          }).length <= 0
        ) {
          showToast(data.error.message);
        }
        if (errorCallback) {
          errorCallback(data);
        }
      }
    },
    error: function (data) {
      if (data.status === 401) {
        delCookie("access_token");
        window?.localStorage?.removeItem("CS_Time");
        let url = window.location.href;
        location.href = "/account/login?returnTo=" + url;
      } else {
        let json = data.responseJSON;
        errorCallback(json);
      }
    },
  });
}

//以成员函数形式设置插件
(function ($) {
  $.fn.extend({
    showLoading: function () {
      let html =
        "<div class='topdon-loading'><div class='loading-bg'><img src='https://cdn.shopifycdn.net/s/files/1/0590/5789/7634/files/loading.gif?v=1676657553'><span>Loading...</span></div></div>";
      if ($(".topdon-loading").length <= 0) {
        this.append(html);
      }

      return this; //为了支持链式操作 要返回当前对象
    },
    hideLoading: function () {
      $(".topdon-loading").remove();
      return this;
    },
    showButtonLoading() {
      this.attr("disabled", "disabled");
      this.html(
        "<img src='https://cdn.shopifycdn.net/s/files/1/0590/5789/7634/files/loading.gif?v=1676657553'>"
      );
    },
    hideButtonLoading(text) {
      this.removeAttr("disabled");
      this.html(text);
    },
  });
})(jQuery);
